<template>
     <div id="chart">
        <apexchart type="pie" width="380" :options="chartOptions" :series="series"></apexchart>
      </div>
</template>
<script>
import firebase from "firebase";
import Apexchart from "vue-apexcharts";
const db = firebase.firestore();
export default {
     components: {
    Apexchart,
  },
  data(){
      return{
            series: [],
          chartOptions: {
            chart: {
              width: 380,
              type: 'pie',
            },
             title: {
          text: "User  donut chart",
        },
            labels: ['Users'],
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }]
          },
      }
  },
  methods:{
        assignsmallData(doc) {
      let smallDocument = {
        id: doc.id,
        name: doc.data().name,
        symbol: doc.data().symbol,
        totalSupply: doc.data().totalSupply,
        companyName: doc.data().companyName,
        description: doc.data().description,
        country: doc.data().country,
        ethereum: doc.data().ethAddress,
        contract: doc.data().conAddress,
        location: doc.data().location,
        logo: doc.data().logo,
      };
      return smallDocument;
    },
    getusers() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("users")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignsmallData(doc));

           

            // this.series = this.userLength.toString();

            // console.log("totalUser",typeof(this.totalUser) )
          });
           this.series.push(this.tableData.length);
          this.loading = false;
        });
    },
  },
  created() {
    this.getusers();
  }
}
</script>